import { Link } from "react-router-dom";

const LOGO_URL = "/brand-logo.png";

export default function Logo({ inverted = false, compact = false }) {
  return (
    <Link to="/" className="flex items-center group" data-testid="site-logo" aria-label="1st Touch Enterprise Holdings, LLC">
      <img
        src={LOGO_URL}
        alt="1st Touch Enterprise Holdings, LLC"
        className={`${compact ? "h-20" : "h-28"} w-auto object-contain`}
      />
    </Link>
  );
}
